import { Component, Inject, OnInit } from '@angular/core';
import { MODAL_CONTROLLER, ModalController } from '../../interfaces/modal';
import { ModalComponent } from '../modal/modal.component';
import { ModalContentComponent } from '../modal-content/modal-content.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'gbc-support-modal',
    templateUrl: './support-modal.component.html',
    styleUrls: ['./support-modal.component.scss'],
    imports: [ModalComponent, ModalContentComponent, TranslateModule]
})
export class SupportModalComponent {

  constructor(
    @Inject(MODAL_CONTROLLER) private controller: ModalController<void>,
  ) { }

  close() {
    this.controller.dismiss();
  }

}
